class UnsubscribeO2dButtonComponent {
  constructor(Orders, toastr, Notifications) {
    Object.assign(this, {
      Orders,
      toastr,
      Notifications,
      unsubscribing: false,
      unsubscribed: false,
      BODACDC_4692: FEATURE_BODACDC_4692,
    });
  }

  unsubscribe() {
    this.unsubscribing = true;
    this.Orders.unsubscribeFromO2D(this.dispenseOrderId, this.orderId)
      .then(({}) => {
        this.unsubscribed = true;
      })
      .catch((err) => {
        if (this.BODACDC_4692) {
          const message = err.status === 403 ? this.Notifications.rxHub.unauthorised : err.message || this.Notifications.generic.failure;
          this.toastr.error(message);
        } else {
          this.toastr.error(err.message);
        }
      })
      .finally(() => {
        this.unsubscribing = false;
      });
  }
}

UnsubscribeO2dButtonComponent.$inject = ['Orders', 'toastr', 'Notifications'];
angular.module('pims').component('unsubscribeO2dButton', {
  templateUrl: 'app/views/visits/list/tabs/rx-hub/components/unsubscribe-o2d/unsubscribe-o2d-button.component.html',
  controller: UnsubscribeO2dButtonComponent,
  controllerAs: 'vm',
  bindings: {
    dispenseOrderId: '=',
    orderId: '=',
  }
});
